const InfoIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ flexShrink: 0, marginTop: "2px" }}>
    <path
      d="M9.0006 12.0002V8.99999M9.0006 5.99975H9.0081M16.5012 8.99999C16.5012 13.1425 13.1431 16.5006 9.0006 16.5006C4.85813 16.5006 1.5 13.1425 1.5 8.99999C1.5 4.85752 4.85813 1.49939 9.0006 1.49939C13.1431 1.49939 16.5012 4.85752 16.5012 8.99999Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default InfoIcon;
